import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=14cd6e8a&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=14cd6e8a&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd6e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14cd6e8a')) {
      api.createRecord('14cd6e8a', component.options)
    } else {
      api.reload('14cd6e8a', component.options)
    }
    module.hot.accept("./tips.vue?vue&type=template&id=14cd6e8a&scoped=true&", function () {
      api.rerender('14cd6e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/tokenList/tips.vue"
export default component.exports